import { useState } from 'react';
import InitFilters from './constants/InitFiltering';
import { getCredit } from './hooks/hook';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState(InitFilters(getCredit));
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [dialog, setDialog] = useState({});
  return {
    loading,
    setLoading,
    setFilterParams,
    size,
    setSize,
    filters,
    setFilters,
    loadingBtn,
    setLoadingBtn,
    dialog,
    setDialog,
    page, setPage
  };
};

export default useCustomHook;
